import { GeogroupService, UserGeogroup } from '@geovelo-frontends/commons';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from './query-keys';

async function updateGroupMembership({
  partnerCode,
  userId,
  prevGroupId,
  newGroupId,
}: {
  newGroupId: number | null;
  partnerCode?: string;
  partnerId?: number;
  prevGroupId: number | null;
  userId?: number;
}): Promise<UserGeogroup | null | undefined> {
  let newGroup: UserGeogroup | null | undefined;
  if (prevGroupId && prevGroupId !== newGroupId) {
    await GeogroupService.leaveGeogroup(prevGroupId, { userId, partnerCode });
    newGroup = null;
  }

  if (newGroupId && prevGroupId !== newGroupId) {
    newGroup = await GeogroupService.joinGeogroup(newGroupId, { userId, partnerCode });
  }

  return newGroup;
}

function useUpdateGroupMembershipMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateGroupMembership,
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partnerSubgroups.all(partnerId) });
    },
  });
}

export default useUpdateGroupMembershipMutation;
